/*
 * OnboardingWelcome — new "step 0" screen shown before the wizard starts.
 * Purely presentational: no data fetching, no ledger writes.
 */
import React from "react";
import AmbientStarfield from "./shared/AmbientStarfield";
import SacredEmblem from "./shared/SacredEmblem";
import "./OnboardingBookends.css";

export const OnboardingWelcome = ({
  userName = "Friend",
  totalSteps = 8,
  onBegin,
  buttonLabel,
  subtext = "Takes about 3 minutes",
  intro,
}) => {
  const label = buttonLabel || "BEGIN";
  const body = intro || (
    <>
      Before we begin, please answer a few basic questions. Share whatever you can.
      This information is the foundation that Agent Eros builds upon during your sessions.
      Skip any fields you cannot fill out, claim your rewards and get started with your first session.
    </>
  );

  return (
    <div className="ob-scene" data-testid="onboarding-welcome">
      <AmbientStarfield />
      <div className="ob-panel">
        <div className="ob-emblem-wrap">
          <SacredEmblem size={170} />
        </div>
        <div className="ob-eyebrow ob-rise">Agent Eros</div>
        <h1 className="ob-title ob-rise ob-rise-1">Welcome, {userName}</h1>
        <p className="ob-body ob-rise ob-rise-2">{body}</p>
        <img
          src="/rewards/icon-divider5.png"
          alt=""
          aria-hidden
          className="ob-divider ob-rise ob-rise-25"
        />
        <div className="ob-dots ob-rise ob-rise-3">
          {Array.from({ length: totalSteps }, (_, i) => (
            <div
              key={i}
              className={`ob-dot ${i === 0 ? "ob-dot-active" : ""}`}
              aria-hidden
            />
          ))}
        </div>
        <button
          className="ob-cta ob-rise ob-rise-4"
          onClick={onBegin}
          data-testid="onboarding-welcome-begin"
        >
          {label}
        </button>
        <div className="ob-sub ob-rise ob-rise-5">{subtext}</div>
      </div>
    </div>
  );
};

export default OnboardingWelcome;
